<template>
    <div>
        <el-row class="type-list">

            <el-col >
                <span v-for="(item,index) in cityByIdList" :class="{active:areaIndex === index}"
                      @click="areaClick(index,item.id)">
                            {{item.name}}
                        </span>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "more-city-template",
        data(){
            return {
                areaIndex:'',
                cityByIdList:[
                    // {
                    //     id:1,
                    //     name:'test地区1'
                    // },
                    // {
                    //     id:2,
                    //     name:'test地区2'
                    // }
                ],
                dictionaryId:'',
            }

        },
        methods:{
            areaClick(index,id) {
                this.areaIndex = index;
                this.dictionaryId = id;
                this.selectTypeList();
            },
            listCity(){
                this.api.schoolPage
                        .getCityList({
                            parentId:'2'
                        })
                        .then(result => {
                            this.cityByIdList=result.data;
                        })
                        .catch(error => {
                            console.log(error);
                        });


            },
        },
        mounted(){
            //获取地区
            this.listCity();

        }
    }
</script>

<style scoped lang="less">

    .type-list {
    background: #fff;
        padding: 15px 5px;
        font-size: 14px;
    span {
        display: inline-block;
        padding: 5px 20px;
        cursor: pointer;
    }
    .active {
        background-color: rgba(30, 111, 255, 1);
        color:rgb(255, 255, 255);
        border-radius: 20px;
    }

    }
</style>


// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/moreCityTemplate.vue